import React, {useEffect, useContext, useRef, useState} from 'react';
import Link from "next/link";
import styled from "styled-components";
import LandingTile from "@organisms/property/landing/tiles";
import IsOwnerBanner from "@molecules/banners/is.owner";
import IsRealtorBanner from "@molecules/banners/is.realtor";
import Icon from "@atoms/icon";
import {UserContext} from "@providers/user";
import {isEmpty} from "@helpers/helpers";
import MostActiveRealtor from "@molecules/realtor/most_active_realtors";
import BrandingText from "@molecules/widgets/branding_text";
import {getSearchFaq} from "@organisms/property/helpers/search_helper";
import FaqsWidget from "@molecules/widgets/faqs";
import ApartmentIcon from '@icons/apartment.svg';
import HouseIcon from '@icons/house.svg';
import CommercialIcon from '@icons/commercial.svg';
import OfficeIcon from '@icons/office.svg';
import Coin1Icon from '@icons/coin.svg';
import Coin2Icon from '@icons/coin2.svg';
import Coin3Icon from '@icons/coin3.svg';
import ArrowLeftIcon from '@icons/arrow-left.svg';
import MostActiveAgencies from "../../../components/organisms/property/components/most_active_agencies";

const PardisHomeLanding = ({mostActiveRealtorsLists, searchNavbarRef, faqsList, setContactInfo, ssrBrandingText}) => {
    const [faqs, setFaqs] = useState(faqsList ?? []);
    const cardRef = useRef('');
    const userContext = useContext(UserContext);
    const authCheck = userContext.check;

    const priceTileItems = [
        {title: 'تا 800 میلیون', href: '/properties', hrefAs: '/املاک-پردیس/خرید-فروش-آپارتمان/قیمت-تا-800-میلیون', icon: <Coin1Icon/>},
        {title: '800 تا 1٫5 میلیارد', href: '/properties', hrefAs: '/املاک-پردیس/خرید-فروش-آپارتمان/قیمت-800-میلیون-تا-1.500-میلیارد', icon: <Coin2Icon/>},
        {title: '1٫5 تا 2٫5 میلیارد', href: '/properties', hrefAs: '/املاک-پردیس/خرید-فروش-آپارتمان/قیمت-1.500-تا-2.500-میلیارد', icon: <Coin3Icon/>},
    ];
    const areaTileItems = [
        {title: 'تا 75 متر', href: '/properties', hrefAs: '/املاک-پردیس/خرید-فروش-آپارتمان/زیربنا-تا-75-متر', icon: <ApartmentIcon/>},
        {title: '75 تا 100 متر', href: '/properties', hrefAs: '/املاک-پردیس/خرید-فروش-آپارتمان/زیربنا-75-تا-100-متر', icon: <ApartmentIcon/>},
        {title: 'بیش از 100 متر', href: '/properties', hrefAs: '/املاک-پردیس/خرید-فروش-آپارتمان/زیربنا-100-متر-به-بالا', icon: <ApartmentIcon/>},
    ];

    useEffect(() => {
        const windowSize = window.innerWidth;
        if (!isEmpty(searchNavbarRef.current)) {
            if (windowSize > 991) {
                const handleScroll = (event) => {

                    if (window.pageYOffset > 82) {
                        searchNavbarRef.current.classList.add('fixed-top');
                        if (!isEmpty(cardRef.current)) {
                            cardRef.current.classList.add('search-navbar-fixed');
                        }

                        if (!isEmpty(document.querySelector('.landing-page-container'))) {
                            document.querySelector('.landing-page-container').classList.add('search-navbar-fixed');
                        }
                    } else {
                        searchNavbarRef.current.classList.remove('fixed-top');
                        if (!isEmpty(cardRef.current)) {
                            cardRef.current.classList.remove('search-navbar-fixed');
                        }

                        if (!isEmpty(document.querySelector('.landing-page-container'))) {
                            document.querySelector('.landing-page-container').classList.remove('search-navbar-fixed');
                        }
                    }
                };

                window.addEventListener('scroll', handleScroll);
                return () => {
                    window.removeEventListener("scroll", handleScroll);
                };
            } else {
                searchNavbarRef.current.classList.remove('fixed-top');
                if (!isEmpty(cardRef.current)) {
                    cardRef.current.classList.remove('search-navbar-fixed');
                }

                if (!isEmpty(document.querySelector('.landing-page-container'))) {
                    document.querySelector('.landing-page-container').classList.remove('search-navbar-fixed');
                }
            }
        }
    });

    useEffect(() => {
        if (!faqs.length) {
            const params = {
                city_id: 3165,
            };

            getSearchFaq(params, 'home').then(widgets => {
                setFaqs(widgets)
            });
        }
    }, []);

    return (
        <React.Fragment>
            <Container ref={cardRef} className="mb-56">
                <Sections className="mt-16 mt-lg-56">
                    <div className="container">
                        <h1 className="mb-16">املاک پردیس</h1>
                        <LandingTile className="apartment" items={areaTileItems} iconSize={16}/>
                    </div>
                </Sections>

                <Sections>
                    <div className="container">
                        <p className="mb-16"><strong className="h2">بر اساس قیمت</strong></p>
                        <LandingTile iconsClassName="price" items={priceTileItems} iconSize={32}/>
                    </div>
                </Sections>

                <Sections className="container">
                    <Link href="/properties" as="/املاک-پردیس/خرید-فروش-آپارتمان/قیمت-2.500-میلیارد-به-بالا">
                        <a>
                            <TehranLux className="rounded-16 d-flex flex-column align-items-center align-items-md-end justify-content-end justify-content-md-center">
                                <h2 className="h1-bold text-white d-flex align-items-end justify-content-between d-md-block">
                                    <span className="">خرید آپارتمان <br/> لوکس و لاکچری </span>
                                    <span className="tehran-banner-icon bg-white rounded-circle mr-24 d-inline-flex align-items-center justify-content-center">
                                    <Icon className=""><ArrowLeftIcon/></Icon>
                                </span>
                                </h2>
                            </TehranLux>
                        </a>
                    </Link>
                </Sections>

                <Sections className="selected-realtors js-most-active-agency-section">

                    <div className="container sm-fluid">
                        <MostActiveAgencies
                            city_id={3165}
                            setContactInfo={setContactInfo}
                            className=""
                            sectionTitle={`املاک منتخب پردیس`}
                        />
                    </div>
                </Sections>

                {
                    !authCheck ?
                        <Sections className="container is-realtor-owner-wrapper">
                            <IsOwnerBanner/>
                        </Sections> :
                        ''
                }

                <Sections className={"container "}>
                    <p className="mb-24 mb-lg-16"><strong className="h2">رهن و اجاره در پردیس</strong></p>

                    <div className="row">
                        <div className="col-6 col-lg-3">
                            <Link href="/properties" as="/املاک-پردیس/رهن-اجاره-آپارتمان">
                                <a>
                                    <div className="bg-info py-32 text-center rounded-8 bg-info-hover">
                                        <Icon height="35"><ApartmentIcon/></Icon>
                                        <div className="font-weight-500">اجاره آپارتمان</div>
                                    </div>
                                </a>
                            </Link>
                        </div>

                        <div className="col-6 col-lg-3">
                            <Link href="/properties" as="/املاک-پردیس/رهن-اجاره-خانه-ویلایی">
                                <a>
                                    <div className="bg-info py-32 text-center rounded-8 bg-info-hover">
                                        <Icon height="35"><HouseIcon/></Icon>
                                        <div className="font-weight-500">اجاره خانه ویلایی</div>
                                    </div>
                                </a>
                            </Link>
                        </div>

                        <div className="col-6 col-lg-3">
                            <Link href="/properties" as="/املاک-پردیس/رهن-اجاره-مغازه-تجاری">
                                <a>
                                    <div className="bg-info py-32 mt-16 mt-lg-0 text-center rounded-8 bg-info-hover">
                                        <Icon height="35"><CommercialIcon/></Icon>
                                        <div className="font-weight-500">اجاره مغازه</div>
                                    </div>
                                </a>
                            </Link>
                        </div>

                        <div className="col-6 col-lg-3">
                            <Link href="/properties" as="/املاک-پردیس/رهن-اجاره-دفتر-کار-اداری">
                                <a>
                                    <div className="bg-info py-32 mt-16 mt-lg-0 text-center rounded-8 bg-info-hover">
                                        <Icon height="35"><OfficeIcon/></Icon>
                                        <div className="font-weight-500">اجاره دفتر کار</div>
                                    </div>
                                </a>
                            </Link>
                        </div>
                    </div>
                </Sections>


                <Sections className="js-active-realtors-last-week">
                    <div className="container">
                        <p className="mb-16"><strong className="h2">کارشناس‌های املاک فعال 7 روز اخیر پردیس</strong></p>
                    </div>
                    <div className="container sm-fluid">
                        <MostActiveRealtor
                            city_id={3165}
                            last_week={true}
                            mostActiveRealtorsLists={mostActiveRealtorsLists}
                            sectionClassName="js-active-realtors-last-week"
                        />
                    </div>
                </Sections>


                {
                    (!authCheck) ?
                        <Sections className={"container is-realtor-banner-wrapper"}>
                            <IsRealtorBanner/>
                        </Sections> :
                        ''
                }

                {
                    (faqs.length) ?
                        <Sections className="container ">
                            <FaqsWidget faqs={faqs}/>
                        </Sections>
                        : ''
                }

                <Sections className={"container "}>
                    <BrandingText skeleton={false} content={ssrBrandingText} searchParams={{city_id: 3165}}/>
                </Sections>
            </Container>
        </React.Fragment>
    );
}

export default React.memo(PardisHomeLanding);

// styles

const Container = styled.div`

  &.search-navbar-fixed {
    margin-top: 120px !important;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 0 !important;
    }
  }

  .most-visited-properties-wrapper {
    a {
      display: block;
      width: 100%;
      margin-top: 16px;
    }
  }
`;

const Sections = styled.section`
  margin-top: 80px;

  .text-hover-green {
    &:hover {
      color: ${props => props.theme.secondary};
    }
  }

  &.is-realtor-banner-wrapper {
    margin-top: 136px !important;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 64px;

    &.is-realtor-banner-wrapper {
      margin-top: 40px !important;
    }
  }
`;

const TehranLux = styled.section`
  background-image: url(/_img/landings/mashhad.jpg?v=1);
  background-color: ${props => props.theme.gray100};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  min-height: 280px;
  padding-left: 80px;


  .tehran-banner-icon {
    width: 28px;
    height: 28px;
  }

  h2 {
    line-height: 1.67;
  }

  .icons {
    width: 16px;
    height: 16px;
    vertical-align: middle;

    svg {
      g {
        stroke-width: 2;
      }
    }
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    min-height: 327px;
    padding: 32px;
    background-image: url(/_img/landings/mashhad-m.jpg?v=1);

    .tehran-banner-icon {
      margin-bottom: 7px;
    }

    h2 {
      width: 100%;

      span.lux-hint {
        font-size: 15px;
        font-weight: normal;
      }
    }

    .icons {
      width: 14px;
      height: 14px;
    }
  }
`;